import React from 'react';
import MUIBreadcrumbs, { BreadcrumbsProps } from '@mui/material/Breadcrumbs';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const Breadcrumbs: React.FC<BreadcrumbsProps> = (props) => (
	<MUIBreadcrumbs separator={<ArrowRightIcon />} {...props} />
);

export default Breadcrumbs;
